module.exports = __webpack_public_path__ + "static/img/Bitmap@2x.0d43a58.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bitmap@2x.png
// module id = Emwv
// module chunks = 1